import { render, staticRenderFns } from "./EmbedScreen.vue?vue&type=template&id=5ab5657e&scoped=true&lang=pug&"
import script from "./EmbedScreen.vue?vue&type=script&lang=js&"
export * from "./EmbedScreen.vue?vue&type=script&lang=js&"
import style0 from "./EmbedScreen.vue?vue&type=style&index=0&id=5ab5657e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab5657e",
  null
  
)

export default component.exports